module.exports = __webpack_public_path__ + "img/transparent_jpg.b64ae8b2.svg";